import React from 'react';
import { motion } from 'framer-motion';
import { Quote } from 'lucide-react';
const testimonials = [{
  quote: "The level of compassion and professionalism from the Crownehealth team is unmatched. They didn't just care for my mother; they brought joy back into her daily routine.",
  author: 'Sarah Jenkins',
  relationship: 'Daughter of Patient'
}, {
  quote: 'After my surgery, the in-home therapy team was incredible. They were patient, encouraging, and tailored every session to my pace. I recovered faster than expected.',
  author: 'Robert Chen',
  relationship: 'Rehabilitation Patient'
}, {
  quote: 'Finding trustworthy care was overwhelming until we found Crownehealth. Their transparent communication and genuine warmth gave our family complete peace of mind.',
  author: 'Elena Rodriguez',
  relationship: 'Family Caregiver'
}];
export function TestimonialsSection() {
  return <section id="testimonials" className="py-24 bg-nude-light" data-id="element-188">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8" data-id="element-189">
        <div className="text-center max-w-2xl mx-auto mb-16" data-id="element-190">
          <motion.h2 initial={{
          opacity: 0,
          y: 20
        }} whileInView={{
          opacity: 1,
          y: 0
        }} viewport={{
          once: true
        }} className="text-4xl md:text-5xl font-serif text-chocolate mb-6" data-id="element-191">
            What Families Say
          </motion.h2>
          <motion.p initial={{
          opacity: 0,
          y: 20
        }} whileInView={{
          opacity: 1,
          y: 0
        }} viewport={{
          once: true
        }} transition={{
          delay: 0.1
        }} className="text-lg text-chocolate/70" data-id="element-192">
            Real stories from the individuals and families we have the privilege
            to serve.
          </motion.p>
        </div>

        <div className="grid md:grid-cols-3 gap-8" data-id="element-193">
          {testimonials.map((testimonial, index) => <motion.div key={index} initial={{
          opacity: 0,
          y: 30
        }} whileInView={{
          opacity: 1,
          y: 0
        }} viewport={{
          once: true
        }} transition={{
          duration: 0.6,
          delay: index * 0.2
        }} className="bg-white rounded-3xl p-8 shadow-soft relative" data-id="element-194">
              <Quote className="absolute top-8 right-8 text-nude opacity-50" size={48} data-id="element-195" />
              <div className="flex gap-1 mb-6" data-id="element-196">
                {[...Array(5)].map((_, i) => <svg key={i} className="w-5 h-5 text-gold fill-current" viewBox="0 0 20 20" data-id="element-197">
                    <path d="M9.049 2.927c.3-.921 1.603-.921 1.902 0l1.07 3.292a1 1 0 00.95.69h3.462c.969 0 1.371 1.24.588 1.81l-2.8 2.034a1 1 0 00-.364 1.118l1.07 3.292c.3.921-.755 1.688-1.54 1.118l-2.8-2.034a1 1 0 00-1.175 0l-2.8 2.034c-.784.57-1.838-.197-1.539-1.118l1.07-3.292a1 1 0 00-.364-1.118L2.98 8.72c-.783-.57-.38-1.81.588-1.81h3.461a1 1 0 00.951-.69l1.07-3.292z" data-id="element-198" />
                  </svg>)}
              </div>
              <p className="text-chocolate/80 text-lg leading-relaxed mb-8 relative z-10" data-id="element-199">
                "{testimonial.quote}"
              </p>
              <div className="mt-auto" data-id="element-200">
                <div className="font-serif font-bold text-chocolate text-lg" data-id="element-201">
                  {testimonial.author}
                </div>
                <div className="text-sm text-chocolate/60" data-id="element-202">
                  {testimonial.relationship}
                </div>
              </div>
            </motion.div>)}
        </div>
      </div>
    </section>;
}